import { useMutation } from '@tanstack/react-query';

import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import {
  ApplicationListCreateRequest,
  ApplicationListResponse,
} from 'src/types/rest/tenant';

export const useCreateApplicationList = () => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useMutation({
    mutationFn: (variables: ApplicationListCreateRequest) =>
      apiRequest<ApplicationListResponse>({
        data: variables,
        method: 'POST',
        url: `${apiHost}/application-lists`,
      }),
  });
};
